import { Fragment, useState, useContext, useRef, useEffect } from "react";
import { Container, Row, Col, TabContent, TabPane } from "reactstrap";
import { useNavigate, Link } from "react-router-dom";
import "./LoginTab.css";
import man from "../../../assets/images/dashboard/profile.png";
import { useDispatch, useSelector } from "react-redux";
import {
  login,
  loginOTP,
  setShowOtpScreenValue,
  clearAuthError,
} from "../../../store/slices/authNewSlice";
import CustomizerContext from "../../../_helper/Customizer";
import { getRoleAccessByEmail } from "../../../store/slices/usersSlice";
import DashboardIcon from "../../../assets/images/logo/img1.png";
import { Image, Btn, P } from "../../../AbstractElements";
import CubaIcon from "../../../assets/images/logo/logo.png";

const OtpInput = () => {
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);

  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);
  const email = useSelector((state) => state.auth.emailValue);
  const password = useSelector((state) => state.auth.passwordValue);
  const showOtpScreen = useSelector((state) => state.auth.showOtpScreen);
  const inputRefs = useRef([]);

  const handleChange = (e, idx) => {
    const value = e.target.value;
    
    // Only allow single digit numbers
    if (!/^\d?$/.test(value)) return;
    
    const newOtp = [...otp];
    
    // Handle paste - if multiple characters, distribute them
    if (value.length > 1) {
      const pastedData = value.slice(0, 6);
      for (let i = 0; i < pastedData.length && idx + i < 6; i++) {
        if (/^\d$/.test(pastedData[i])) {
          newOtp[idx + i] = pastedData[i];
        }
      }
      setOtp(newOtp);
      // Focus the next empty box or last box
      const nextEmptyIndex = newOtp.findIndex((val, i) => i > idx && !val);
      if (nextEmptyIndex !== -1) {
        inputRefs.current[nextEmptyIndex]?.focus();
      } else {
        inputRefs.current[5]?.focus();
      }
      return;
    }
    
    // Regular single character input
    newOtp[idx] = value;
    setOtp(newOtp);
    
    // Auto-advance to next box if value entered
    if (value && idx < otp.length - 1) {
      inputRefs.current[idx + 1]?.focus();
    }
  };
  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];
      
      if (otp[idx]) {
        // Clear current box
        newOtp[idx] = "";
        setOtp(newOtp);
      } else if (idx > 0) {
        // Move to previous box and clear it
        newOtp[idx - 1] = "";
        setOtp(newOtp);
        inputRefs.current[idx - 1]?.focus();
      }
    } else if (e.key === "ArrowLeft" && idx > 0) {
      e.preventDefault();
      inputRefs.current[idx - 1]?.focus();
    } else if (e.key === "ArrowRight" && idx < otp.length - 1) {
      e.preventDefault();
      inputRefs.current[idx + 1]?.focus();
    } else if (e.key === "Delete") {
      e.preventDefault();
      const newOtp = [...otp];
      newOtp[idx] = "";
      setOtp(newOtp);
    }
  };
  
  const handleFocus = (e) => {
    // Select all text on focus for easier replacement
    e.target.select();
  };
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const loginAuth = async (e) => {
    e.preventDefault();
    dispatch(login({ email, password }))
      .unwrap()
      .then((user) => {
        setOtp(["", "", "", "", "", ""]);
        setTimer(60);
      })
      .catch((err) => {
        console.error("Failed to login: ", err);
      });
  };

  const loginOTPFunc = async (e) => {
    const otpValue = otp.join("");
    
    // Security Fix: Validate OTP format before sending to backend
    if (otpValue.length !== 6 || !/^\d{6}$/.test(otpValue)) {
      console.error("Invalid OTP format");
      return;
    }
    
    await dispatch(loginOTP({ email, password, otpValue }))
      .unwrap()
      .then((response) => {
        // Security Fix: Validate success flag and user data
        // Token is ONLY in HTTP-only cookie, never exposed to JavaScript
        if (!response || !response.success || !response.user) {
          console.error("Authentication failed: Invalid server response");
          // Clear OTP and force re-entry
          setOtp(["", "", "", "", "", ""]);
          return;
        }
        
        localStorage.setItem("profileURL", man);
        localStorage.setItem("Name", response.user.email || email);
        localStorage.setItem("login", JSON.stringify(true));
        localStorage.setItem("authenticated", JSON.stringify(true));
        
        dispatch(getRoleAccessByEmail({ email })).unwrap();
        
        // Handle password reset flow
        if (response.is_new_password_set === false) {
          history(`${process.env.PUBLIC_URL}/set-password`, {
            state: {
              user: response.user,
              access_token: response.access_token,
            },
          });
        } else {
          history(`${process.env.PUBLIC_URL}/pages/dashboard`);
        }
        
        dispatch(setShowOtpScreenValue(false));
      })
      .catch((err) => {
        console.error("Failed to login: ", err);
        setOtp(["", "", "", "", "", ""]);
      });
  };
  useEffect(() => {
    if (showOtpScreen) {
      setOtp(["", "", "", "", "", ""]);
      setTimer(60);
    } else {
      history(`${process.env.PUBLIC_URL}/login`);
    }
  }, [showOtpScreen]);
  useEffect(() => {
    if (timer === 0) {
      setOtp(["", "", "", "", "", ""]);
      dispatch(clearAuthError());
    }
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => {
      if (interval !== undefined) {
        clearInterval(interval);
      }
    };
  }, [timer, dispatch]);
  return (
    <Container fluid={true} className="p-0 login-page">
      <Row>
        <Col xs="12">
          <div className="login-card">
            <div className="login-main login-tab">
              <TabContent className="content-login">
                <TabPane className="fade show">
                  <Fragment>
                    {showOtpScreen && (
                      <>
                        <div className="text-center">
                          <Link
                            to={`${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`}
                          >
                            <Image
                              attrImage={{
                                className: "img-fluid d-inline",
                                src: `${CubaIcon}`,
                                alt: "",
                              }}
                            />
                          </Link>
                          <h5 className="mt-3">Validate OTP to Login</h5>
                        </div>
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            if (otp.join("").length === 6) {
                              loginOTPFunc(e);
                            }
                          }}
                        >
                          <div className="text-center">
                            <h7 className="mt-3">
                              Enter OTP sent to <b>{email}</b>
                            </h7>
                            <div className="flex gap-4 justify-center my-4" style={{ display: "flex", gap: "12px", justifyContent: "center", margin: "24px 0" }}>
                              {otp.map((digit, idx) => (
                                <input
                                  key={`otp-input-${idx}`}
                                  ref={(el) => (inputRefs.current[idx] = el)}
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={1}
                                  className="otp-input"
                                  value={digit}
                                  onChange={(e) => handleChange(e, idx)}
                                  onKeyDown={(e) => {
                                    handleKeyDown(e, idx);
                                    if (
                                      e.key === "Enter" &&
                                      otp.join("").length === 6
                                    ) {
                                      loginOTPFunc(e);
                                    }
                                  }}
                                  onFocus={handleFocus}
                                  autoFocus={idx === 0}
                                  style={{
                                    width: "52px",
                                    height: "60px",
                                    textAlign: "center",
                                    fontSize: "24px",
                                    fontWeight: "600",
                                    border: "2px solid #ddd",
                                    borderRadius: "8px",
                                    backgroundColor: "#f8f9fa",
                                    transition: "all 0.3s ease",
                                  }}
                                />
                              ))}
                            </div>
                            <div className="text-center text-danger">
                              {error && <P>{error.message}</P>}
                            </div>
                            {timer !== 0 && (
                              <div className="text-center text-gray-500 mb-4 text-lg">
                                {`00:${timer.toString().padStart(2, "0")}`}
                              </div>
                            )}
                            <div className="text-center mb-2">
                              {loading ? (
                                <Btn
                                  attrBtn={{
                                    color: "danger",
                                    disabled: "disabled",
                                  }}
                                >
                                  Submitting....
                                </Btn>
                              ) : (
                                <Btn
                                  attrBtn={{
                                    color: "danger",
                                    onClick: (e) => {
                                      loginOTPFunc(e);
                                    },
                                    disabled: otp.join("").length !== 6,
                                  }}
                                >
                                  Submit
                                </Btn>
                              )}
                            </div>
                            {timer === 0 && (
                              <div
                                style={{
                                  fontSize: "14px",
                                  color: "#888",
                                  marginTop: "8px",
                                }}
                              >
                                Didn't receive OTP ?{" "}
                                <button
                                  type="button"
                                  style={{
                                    color: "#6c63ff",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    font: "inherit",
                                  }}
                                  onClick={(e) => loginAuth(e)}
                                >
                                  Resend
                                </button>
                              </div>
                            )}
                          </div>
                        </form>
                      </>
                    )}
                  </Fragment>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default OtpInput;
